import {useMutation} from "@apollo/client";
import {toast} from "react-hot-toast";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {
  GQL_STATUS_PAGE_QUERY,
  GQL_STATUSPAGE_COMPONENTS,
  GQL_UPDATE_COMPONENT,
  UpdateComponentResult,
} from "@/lib/queries/statuspages.ts";
import {Component, ComponentStatus} from "@/lib/types/statuspages.ts";
import StatusPageUpdateComponentForm from "@/pages/statuspages/tabs/components/componentModal/StatusPageUpdateComponentForm.tsx";

interface StatusPageComponentUpdateModalProps {
  className?: string;
  title: string;
  submitBtnText?: string;
  component?: Component;
  statusPageID: number;
  components: Component[];
  componentStatuses: ComponentStatus[];
  setShow: (show: boolean) => void;
  show: boolean;
}

interface StatusPageComponentUpdateFormValues {
  id?: number;
  name: string;
  description: string;
  group?: number;
  service?: number;
  auto_status_down?: string;
  auto_status_up?: string;
}

export const StatusPageComponentUpdateModal = ({
  component,
  title,
  show,
  setShow,
  statusPageID,
  components,
  componentStatuses,
}: StatusPageComponentUpdateModalProps) => {
  const [updateComponent, {data, loading, reset}] = useMutation<UpdateComponentResult>(GQL_UPDATE_COMPONENT, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_STATUSPAGE_COMPONENTS],
  });
  const formId = "addNewComponent";
  const handleSubmit = async (data: StatusPageComponentUpdateFormValues) => {
    const response = await updateComponent({
      variables: {
        statusPageID: statusPageID,
        data: {
          ...data,
          auto_status_up: data.service ? data.auto_status_up : "",
          auto_status_down: data.service ? data.auto_status_down : "",
        },
      },
    });
    setShow(!response?.data?.updateComponent?.success);
    if (response?.data?.updateComponent?.success) {
      const toastMessage = component ? "Component updated." : "Component created.";
      toast.success(toastMessage);
    }
  };

  return (
    <FormModal
      className="px-2"
      placement="end"
      size="lg"
      disabled={loading}
      formId={formId}
      hasRequiredFields
      onCancel={() => {
        setShow(false);
        reset();
      }}
      show={show}
      title={title}
    >
      <StatusPageUpdateComponentForm
        componentGroups={components.filter((c) => c.is_group)}
        id={formId}
        component={component}
        serverErrors={data?.updateComponent?.errors}
        componentStatuses={componentStatuses}
        onSubmit={handleSubmit}
      />
    </FormModal>
  );
};
